import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { leagueEventStore } from 'state/league/leagueEvent'
import RequestMentorModal from 'pages/Events/Views/Common/Modals/RequestMentorModal'

const MentorRequest: React.FC = () => {
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const [mentorRequestModal, setMentorRequestModal] = useState<boolean>(false)
  return (
    <>
      <div onClick={() => setMentorRequestModal(true)}>
        <IconsTextNavigation
          iconName="MagnifyingGlass"
          heading="Mentor Request"
          isCompleted={leagueData?.mentorRequestIds?.length ? true : false}
        />
      </div>
      {mentorRequestModal && (
        <RequestMentorModal
          openModal={mentorRequestModal}
          setOpenModal={setMentorRequestModal}
          reference="league"
          referenceId={leagueData._id}
        />
      )}
    </>
  )
}

export default MentorRequest
